import {IUpdateUserProfileRequest, space, UpdateUserProfileRequest, UpdateUserProfileResponse} from "../../compiled";
import {useRpcSender} from "../../RpcSender";
import {RpcState} from "../RpcState";
import {useState} from "react";
import {useProfile} from "../../UserProfileProvider";
import IErrorProto = space.kenko.proto.IErrorProto;

export const useUpdateUserProfileRpc = () => {

  const {setProfile} = useProfile();
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'})
  const [errors, setErrors] = useState<IErrorProto[]>([]);

  const reset = () => {
    setRpcState({state: 'none'});
    setErrors([]);
  }
  
  const send = (request: IUpdateUserProfileRequest, onSuccess: () => void) => {

    setRpcState({state: 'pending'});
    setErrors([]);
    rpcSender.send('update_profile', UpdateUserProfileRequest.encode(request).finish())
        .then(value => {
          const response = UpdateUserProfileResponse.decode(value);
          setErrors(response.errors);
          setRpcState({state: response.okay ? 'success' : 'error'})

          if (response.okay && response.updatedProfile) {
            setProfile(response.updatedProfile);
            onSuccess();
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error updating your profile. Please try again later.'});
        });
    return;
  }

  return {rpcState, errors, reset, send}
}